import background from "../img/book.jpg"
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as constants from "../constants.js"

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                await axios.create({ withCredentials: true })
                    .get("//" + constants.BASE_URL + "/getMyRegionIds");
                navigate('/');
            } catch {
                // not logged in, stay on login page
            }
        })();
    }, []);

    const handleSubmit = async (e) => {
        try{
            e.preventDefault()
            
            const resp = await axios.create({
                withCredentials: true,
            }).post("//" + constants.BASE_URL + "/login", {
            email,
            password,
            });
            navigate('/');
        }
        catch{
            setError("Ihre Logindaten sind falsch.")
        }
        
    };


    return ( 
        <div className="signin-wrapper" style={{backgroundImage: `url(${background})`}}>
        <div className="signin-box">
            <h2 className="slim-logo">
                <a href="login">
                    Login
                </a>
            </h2>
            <div className="form-group">
                <form onSubmit={handleSubmit}>
                    <label>E-Mail:</label>
                    <input 
                    type="text" 
                    required 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    />
                    <label>Passwort:</label>
                    <input
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    ></input>
                    <button className="btn-signin">Login</button>
                </form>
            </div> 
            {error && <div className="alert">
                {error}
            </div>}
            <p className="mg-b-0 text-center">
                <a href="impressum" target="_blank">Impressum</a> -
                <a href="datenschutz" target="_blank">Datenschutzerklärung</a> -
                <a href="forgot-password">Passwort vergessen</a>
            </p>
        </div>
    </div>
     );
}
 
export default Login;